'use strict';

angular.module('sis-common.datepicker', []).constant('sisDatepickerConfig', {
  format: 'dd.MM.yyyy',
  altInputFormats: ['d!.M!.yyyy', 'yyyy-M!-d!'],
  defaultOptions: {
    startingDay: 1
  }
});